export const MAX_GROUP_NAME_LENGTH = 22;
export const MAX_FILE_SIZE = 10485760;
export const DEFAULT_EMOJIS = ['1f600', '1f44c', '1f440'];
